import { getOptInStatusDisplay } from '../../../utils/client-helpers'
import { InfoCard } from './info-card'
import { InfoSection } from './info-section'
import { SectionHeading } from './info-section-heading'

import type { PhoneNumber } from '../../../hooks/clients/queries'

function SubscriptionStatusCard({
  phoneNumbers,
}: {
  phoneNumbers: Array<PhoneNumber>
}) {
  return (
    <InfoCard>
      <InfoSection>
        <SectionHeading>Subscription Status:</SectionHeading>
        <div>
          <div className="text-ion-color-primary">
            {getOptInStatusDisplay(phoneNumbers)}
          </div>
        </div>
      </InfoSection>
    </InfoCard>
  )
}

export { SubscriptionStatusCard }
